export const getWebsiteLink = (link: string) => {
  const withoutHttp = link.replace('https://', '').replace('http://', '')
  return withoutHttp[withoutHttp.length - 1] === '/'
    ? withoutHttp.slice(0, withoutHttp.length - 1)
    : withoutHttp
}
